import request from 'superagent'
import { customerFunctions } from 'packs/customers/functions'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { addToast } from 'src/toasts'
import { camelize, isRole } from 'src/misc'
import { showGoogleMap } from 'src/googleMap'

let customersDatatable

export default () => {
  customerFunctions()

  // set dropdown values from local storage
  const customersIndexSelectBu = localStorage.getItem("customersIndexSelectBu")
  if (customersIndexSelectBu) {
    $("#select-bu").val(customersIndexSelectBu.split(','))
  }
  const customersIndexSelectStatus = localStorage.getItem("customersIndexSelectStatus")
  if (customersIndexSelectStatus) {
    $("#select-status").val(customersIndexSelectStatus)
  }
  const customersIndexSelectDimension = localStorage.getItem("customersIndexSelectDimension")
  if (customersIndexSelectDimension) {
    $("#select-dimension").val(customersIndexSelectDimension)
  }
  
	// datatable init
  customersDatatable = $('#customers-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('customersIndexPageLength') || 25),
    "processing": true,
    "responsive": true,
    "serverSide": true,
    "ajax": {
      "url": $('#customers-datatable').data('source'),
      "data": function (d) {
        d.bu = $('#select-bu').val()
        d.status = $('#select-status').val()
        d.dimension = $('#select-dimension').val()
      }
    },
    "columns": [
      { "data": "company_name" },
      { "data": "location_name" },
      { "data": "business_id" },
      { "data": "dimension" },
      { "data": "business_unit" },
      { "data": "industry" },
      { "data": "address" },
      { "data": "contact_person" },
      { "data": "phone" },
      { "data": "email" },
      { "data": "status" },
      { "data": "actions", "orderable": false }
    ],
    "columnDefs": [
      { targets: [5], visible: isRole('MYYJÄ') }
    ],
    initComplete(settings, json) {
      $("#datatable-actions").prependTo('#customers-datatable_wrapper')
      $("#customers-datatable_length").prependTo('#datatable-actions')
      $("#customers-datatable_length").addClass('me-3')
      $("#customers-datatable_filter input").removeClass('form-control-sm').addClass('datatable-search').attr("type", 'text').detach().prependTo('#search-div')
      $('#customers-datatable_wrapper .row:first').remove()
      $("#datatable-actions").removeClass('d-none')

      $('.datatable-search').on('input', function() {
        if ($('#search-div input').val()) {
          $('.clear-button').removeClass('d-none')
        } else {
          $('.clear-button').addClass('d-none')
        }
      })

      $('#select-bu').select2({
        minimumInputLength: 0,
        placeholder: I18n.t("selects.select_business_unit"),
        width: '100%'
      })
  	}
  })

  $('#content').on('change', '#select-bu, #select-status, #select-dimension', function() {
    localStorage.setItem(camelize('customers-index-' + $(this).attr('id')), $(this).val())
    customersDatatable.ajax.reload()
  })

  $('#content').on('change', "[name='customers-datatable_length']", function() {
    localStorage.setItem('customersIndexPageLength', $(this).val())
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    customersDatatable.search('').draw()
  })

  $('#content').on('click', '#add_customer', function() {
    lockButton('#add_customer')
    offcanvasRight.show()
    $.getScript('/customers/new')
  })

  $('#content').on('click', '#import_customers', function() {
    $("#mainModal").html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + I18n.t("import_customers_modal.title") + '</h4><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><a href="/files/asiakkaat tuonti.xlsx">' + I18n.t("import_customers_modal.download") + '</a><br/><br/><ul><li>' + I18n.t("import_customers_modal.body1") + '</li><li>' + I18n.t("import_customers_modal.body2") + '</li><li>' + I18n.t("import_customers_modal.body3") + '</li><li>' + I18n.t("import_customers_modal.body4") + '</li><li>' + I18n.t("import_customers_modal.body5") + '</li><li>' + I18n.t("import_customers_modal.body6") + '</li><li>' + I18n.t("import_customers_modal.body7") + '</li><li>' + I18n.t("import_customers_modal.body8") + '</li></ul><br/><input type="file" id="importCustomersFile"><br/><br/><input class="form-check-input" type="checkbox" value="1" id="sendStarttilomake"><label for="sendStarttilomake" class="ms-2">' + I18n.t("import_customers_modal.checkbox1") + '</label></div><div class="modal-footer"><button id="confirmImportCustomers" type="button" class="btn btn-success"><i class="bi bi-check-lg"></i> ' + I18n.t("buttons.import") + '</button></div></div></div>')
    mainModal.show()

    unlockButton(event.target)
  })

  $('#mainModal').on('click', '#confirmImportCustomers', function() {
    lockButton('#confirmImportCustomers')

    let files = $('#importCustomersFile')[0].files
    if (files.length > 0) {
      request.post('/customers/import_customers')
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .attach('file', files[0])
        .field('send_starttilomake', $('#sendStarttilomake').is(':checked'))
        .field('send_to_nav', $('#sendToNav').is(':checked'))
        .then(res => {
          setTimeout(() => checkStatus(res.body.jobId), 1000)
        })
        .catch(err => {
          // err.message, err.response
          const message = err.response !== undefined && err.response.body !== undefined && err.response.body !== null ? err.response.body : null
          if (err.response.status === 401) {
            if (message !== null) {
              addToast(message, 'error')
              setTimeout(function() {
                $.getScript('/redirect_to_root')
              }, 3000)
            } else {
              $.getScript('/redirect_to_root')
            }
          } else {
            addToast(message, 'error')
            mainModal.hide()
          }
        })
    } else {
      addToast(I18n.t("errors.no_file"), 'alert')
      unlockButton('#confirmImportCustomers')
    }
  })

  $('#content').on('click', '#customers, #contact_people', function(event) {
    lockButton(event.target)
    let status = $('#select-status').val()
    let dimension = $('#select-dimension').val()
    let query = $('#search-div input').val()
    let url = $(event.target).attr('id')
    let q = '/customers/' + url + '_list?status=' + status + '&dimension=' + dimension + '&query=' + query
    
    if ($('#select-bu').length) {
      q += '&bu=' + $('#select-bu').val()
    }

    let dynamicLink = $('<a>', {
      href: q,
      target: '_blank',
      css: { display: 'none' }
    })

    $('body').append(dynamicLink)
    dynamicLink[0].click()
    dynamicLink.remove()

    unlockButton(event.target)
  })

  $('#content').on('click', '#map', function(event) {
    lockButton(event.target)

    const status = $('#select-status').val()
    const dimension = $('#select-dimension').val()
    const query = $('#search-div input').val()
    let url = '/customers/address_list?status=' + status + '&dimension=' + dimension + '&query=' + query
    
    if ($('#select-bu').length) {
      url += '&bu=' + $('#select-bu').val()
    }

    request.get(url)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        let addresses = []
        $.each(res.body.addresses, function(index, value) {
          const totalAddress = (value.street_name + ', ' + value.post_code + ' ' + value.town).trim()
          let title = value.company_name
          if (value.location_name) {
            title += ', ' + value.location_name
          }
          if (totalAddress.length > 1) {
            addresses.push({ address: totalAddress + ', ' + value.country, title: title + "\n" + totalAddress, color: value.color })
          }
        })

        unlockButton(event.target)
        if (addresses.length) {
          showGoogleMap(mainModal, '', addresses)
        } else {
          addToast(I18n.t("errors.no_addresses"), 'alert')
        }
      })
      .catch(err => {
        handleErrors(err, event.target)
      })
  })

  $('#content').on('click', '.show-googlemap', function(event) {
    $(event.target).prop("disabled", true)

    const companyName = $(this).data('company_name')
    const locationName = $(this).data('location_name')
    const streetName = $(this).data('street_name')
    const postCode = $(this).data('post_code')
    const town = $(this).data('town')
    const country = $(this).data('country')
    const totalAddress = (streetName + ", " + postCode + " " + town).trim()
    if (totalAddress.length > 1) {
      let title = companyName
      if (locationName) {
        title += ', ' + locationName
      }
      
      const clientId = $(this).data('client_id')
      const buId = $(this).data('business_unit_id')
      request.get('/clients/' + clientId + '/business_units?id=' + buId)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        showGoogleMap(mainModal, title, [{ address: totalAddress + ", " + country, color: res.body[0].color }])
        $(event.target).prop("disabled", false)
      })
      .catch(err => {
        handleErrors(err, event.target)
      })
    } else {
      addToast(I18n.t("errors.no_address"), 'alert')
    }

    $(event.target).prop("disabled", false)
  })
}

function checkStatus(jobId) {
  request.get(`/background_jobs/${jobId}`)
    .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
    .accept('json')
    .then(res => {
      if (res.body.done === 1) {
        addToast(I18n.t("import_customers_modal.success"), 'notice')
        customersDatatable.ajax.reload()
        mainModal.hide()
      } else if (res.body.done === -1) {
        const error = I18n.t("import_customers_modal.error") + '<br/>' + res.body.error_message
        addToast(error, 'error')
        mainModal.hide()
      } else {
        setTimeout(() => checkStatus(jobId), 1000); // Poll every 1 seconds
      }
    });
}
